import React from 'react';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { VehicleModel } from 'client/data/models/vehicle';
import { SelectComponent } from 'site-modules/shared/components/vehicle-dropdowns/select-component';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';
import { filterPubStates } from 'site-modules/shared/utils/publication-states';
import { DEFAULT_CLASSNAMES, ALL_MAKES_OPTION } from './constants';

const stateToPropsConfig = {
  options: bindToPath('makesList', VehicleModel, (makeData, { pubStates, includeAllMakes, valueKey, labelKey }) =>
    includeAllMakes
      ? [
          { [valueKey]: ALL_MAKES_OPTION.slug, [labelKey]: ALL_MAKES_OPTION.name },
          ...filterPubStates(makeData, pubStates),
        ]
      : filterPubStates(makeData, pubStates)
  ),
};

const ConnectedMakeDropdown = connectToModel(SelectComponent, stateToPropsConfig);
const ConnectedStyledMakeDropdown = connectToModel(StyledSelect, stateToPropsConfig);

export function MakeDropdown({
  labelText = 'Make',
  isLabelHidden = true,
  name = 'select-make',
  toggle = 'Select Make',
  valueKey = 'slug',
  labelKey = 'name',
  includeAllMakes = false,
  className = `js-makes-select ${DEFAULT_CLASSNAMES}`,
  ...restProps
}) {
  return (
    <ConnectedMakeDropdown
      {...restProps}
      labelText={labelText}
      isLabelHidden={isLabelHidden}
      name={name}
      toggle={toggle}
      valueKey={valueKey}
      labelKey={labelKey}
      includeAllMakes={includeAllMakes}
      className={className}
    />
  );
}

export function StyledMakeDropdown({
  labelText = 'Make',
  isLabelHidden = true,
  name = 'select-make',
  toggle = 'Select Make',
  valueKey = 'slug',
  labelKey = 'name',
  includeAllMakes = false,
  ...restProps
}) {
  return (
    <ConnectedStyledMakeDropdown
      {...restProps}
      labelText={labelText}
      isLabelHidden={isLabelHidden}
      name={name}
      toggle={toggle}
      valueKey={valueKey}
      labelKey={labelKey}
      includeAllMakes={includeAllMakes}
    />
  );
}
